import { isServer } from '../environment';
import { IWixSdk } from '@wix/js-sdk-wrapper';

const Wix: IWixSdk = !isServer ? require('@wix/js-sdk-wrapper').WixSdk : {};

function subscribe(event, fn) {
  Wix.addEventListener(event, fn);

  return () => {
    Wix.removeEventListener(event, fn);
  };
}

export { subscribe };

export default Wix;
